@if (collapsible) {
  <app-collapse [collapse]="content">
    <div class="p-3 fw-bold text-dark">Legend</div>
  </app-collapse>
} @else {
  <div class="row">
    <div class="col">
      <ul class="d-flex flex-wrap justify-content-center m-0 p-0 collapse">
        @for (label of getAllLabels(); track label) {
          <li (click)="toggleVisibility(label)"
              [ngClass]="hiddenLabels.includes(label) ? 'text-secondary hidden-label' : ''"
              class="list-group-item d-flex flex-row justify-content-center p-2"
              style="cursor: pointer; border-width: 1px;">
            <div class="me-sm-2 align-self-center" style="width: 20px; height: 20px; ;"
                 [ngStyle]="{'background-color': getDatasetColor(label)}"></div>
            <span class="d-none d-sm-block">{{ label }}</span>
          </li>
        }
      </ul>
    </div>
    <div class="col-auto">
      <a type="button" class="btn btn-outline-info" (click)="toggleSelect()">{{ selectText }}</a>
    </div>
  </div>
}

